export function createQiniuKey(folderName, fileType) {
  return `${folderName}/${new Date().getTime()}_${Math.floor(Math.random() * 1000) + 1}.${fileType || 'jpg'}`
}

export function createQiniuUrl(key) {
  return `https://late-care.tuolele.cn/${key}`
}
